import React, { useEffect, useState } from 'react';
import backicon from "../../../../../Assets/icons/backIcon.svg";
import { useLocation, useNavigate } from 'react-router-dom';
import axiosInstance from '../../../../services/api/API';

import ROUTES_NAVIGATION from '../../../../../routes/routes';
import VehicleDetails from '../../SalesComponents/VehicleDetails';

const CustomerDetailsList = () => {

  const [ personalDetailsData, setPersonalDetailsData ] = useState([])
const navigate = useNavigate()

  const token = localStorage.getItem("authToken");


  const location = useLocation();
    const { data } = location.state || {};
  

  useEffect(() => {
    persoanlDetails()
  },[])

  
  const persoanlDetails = async () => {
    try{
      const response = await axiosInstance.post(`/salesvisit/personaldetails`,{
    business_partner_id:1,
    visit_id: data.visit_id

      },{
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
    })

    const formatedData = response?.data?.data?.data[0]
    console.log(formatedData, "RESPONSE")

    setPersonalDetailsData(formatedData)
  
  }catch(error){
      console.log(error)
    }
  }




  return (
    <div>
      <div className="" >
        <div style={{paddingBottom:"35px", borderBottom:"1px solid lightgray", padding:"35px"}}>
      <span style={{fontWeight:"300", fontSize:"12px", paddingBottom:"5px", color:"gray", paddingLeft:"15px"}}>Sales / Customer Visit / Customer Visit Details</span>
      <div className="backbutton" onClick={()=>navigate("/manage-sales/customer")} >
        <img src={backicon} alt="back" />
          <span className="backbtntitleDetails"> Personal Details</span>
          
      </div>
        </div>
        
        <div >
        <div className="" >
        <h5 style={{paddingLeft:"55px"}} className='mt-2 mb-2 header-details'>Personal Details</h5>
          <div className="detail-grid" style={{ paddingBottom:"30px", borderBottom:"1px solid lightgray", paddingLeft:"57px", paddingTop:"15px"}}>
            <div className="details-item">
              <span className="details-label">Lead No.</span>
              <span className="details-value">{personalDetailsData.lead_id}  </span>
             
            </div>
            <div className="details-item">
              <span className="details-label">Customer Name</span>
              <span className="details-value">{personalDetailsData.customer_name} r</span>
              
            </div>
            <div className="details-item">
              <span className="details-label">Contact No.</span>
              <span className="details-value">{personalDetailsData.mobile_no} </span>
              
            </div>
            {/* <div className="details-item">
              <span className="details-label">Customer Type</span>
              <span className="details-value"> {personalDetailsData.visit_type_name} </span>
             
            </div> */}
            {/* <div className="details-item">
              <span className="details-label">Quotation Type</span>
              <span className="details-value">New Lead</span>
            </div> */}

            <div className="details-item">
              <span className="details-label">Customer Visit Type</span>
              <span className="details-value">{personalDetailsData.customer_visit_type_name}</span>
            </div>

            <div className="details-item">
              <span className="details-label">Visit Date & Time</span>
              {new Date(personalDetailsData.visit_date).toLocaleString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
              })}
            </div>

            <div className="details-item">
              <span className="details-label">Transaction Code</span>
              <span className="details-value"> {personalDetailsData.transaction_code} </span>
            </div>

            {/* <div className="details-item">
              <span className="details-label">Sales Person</span>
              <span className="details-value">Harikesh Gaur</span>
            </div> */}
            <div className="details-item">
              <span className="details-label">Address</span>
              <span className="details-value">{personalDetailsData.address} </span>
            </div>

            <div className="details-item">
              <span className="details-label">PIN Code</span>
              <span className="details-value">{personalDetailsData.pincode}</span>
            </div>

            <div className="details-item">
              <span className="details-label">City</span>
              <span className="details-value">{personalDetailsData.city_name} </span>
            </div>

            <div className="details-item">
              <span className="details-label">State</span>
              <span className="details-value">{personalDetailsData.state_name} </span>
            </div>

            <div className="details-item">
              <span className="details-label">Country</span>
              <span className="details-value">{personalDetailsData.country_name} </span>
            </div>

          </div>

        </div>
        </div>

        {/* ------------------------ */}
        <div >
          <div className="" >
          <VehicleDetails  visit_id ={data.visit_id} />
        </div>
        </div>

      </div>
    </div>
  )
}

export default CustomerDetailsList